import type { NotificationFields } from '@tribeplatform/gql-client/graphql'
import type {
  PaginatedNotification,
  QueryNotificationsArgs,
} from '@tribeplatform/gql-client/types'

import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '../../lib/react-query/useInfiniteQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getNotificationsKey } from '../../utils/keys/notification.key.js'

export const DefaultNotificationLimit = 10

export const useNotifications = (options: {
  variables: QueryNotificationsArgs
  fields?: NotificationFields
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedNotification>
}) => {
  const {
    variables = { limit: DefaultNotificationLimit },
    fields = {
      target: { media: 'basic' },
      space: 'basic',
      actor: { media: 'basic' },
      object: {
        media: 'basic',
      },
    },
    useInfiniteQueryOptions,
  } = options || {}

  const { client } = useTribeClient()
  const notificationsKey = getNotificationsKey({ variables, fields })

  return useInfiniteQuery<PaginatedNotification>(
    notificationsKey,
    ({ pageParam: after }) =>
      client?.notifications.list(
        {
          after,
          ...variables,
        },
        fields,
      ),
    useInfiniteQueryOptions,
  )
}
